var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$store.getters.user.id == "H2kEJMbkyxUhcAfKH1jcMeDOn442" ||
    this.$store.getters.user.id == "b8Yc6Iz0ktV6ofVC1lHgCJ3EQCn1" ||
    this.$store.getters.user.id == "OkvqiVsL6cc4hdaOL97QWU7gCEM2" ||
    this.$store.getters.user.id == "L8ZKmImHhpbKQEbNVVTzzwj4pls1" ||
    this.$store.getters.user.id == "QBRXqktYi0QigFboM92crKAONKn1"
    ? _c(
        "v-container",
        [
          _c("v-date-picker", {
            attrs: { landscape: _vm.landscape, type: "month" },
            model: {
              value: _vm.picker,
              callback: function($$v) {
                _vm.picker = $$v
              },
              expression: "picker"
            }
          }),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.businesses_with_submissions,
              pagination: _vm.pagination,
              "hide-actions": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c("tr", [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-center" }, [
                        _vm._v(_vm._s(props.item.total))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-center" }, [
                        _vm._v(_vm._s(props.item.paid))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-center" }, [
                        _vm._v(_vm._s(props.item.free))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-center" }, [
                        _vm._v(_vm._s(props.item.responses))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-center" }, [
                        _vm._v(_vm._s(props.item.awaiting))
                      ])
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa1046a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa1046a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/monthly_report.vue
// module id = null
// module chunks = 